import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";
import { useCan, PermInput } from "../../auth";
import { LinearProgress, Box } from "@mui/material";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermission: PermInput | PermInput[];
  redirectTo?: string;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({
  children,
  requiredPermission,
  redirectTo = "/brands"
}) => {
  const { user, meLoaded } = useAuthStore();
  const can = useCan();

  // Wait for /auth/me before deciding, to avoid a premature redirect.
  if (user && !meLoaded) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <LinearProgress sx={{ width: "50%" }} />
      </Box>
    );
  }

  return can(requiredPermission) ? children : <Navigate to={redirectTo} replace />;
};

export default ProtectedRoute;
